/**
 * Contenu provisoire des pages annexes (CGU, mentions légales, confidentialité,
 * FAQ), repris des maquettes du dossier zorni-refonte-template.
 *
 * ATTENTION — ce texte n'a PAS été validé juridiquement. Il est là pour que les
 * pages existent et que les liens du pied de page aient une destination. Tout
 * ce qui engage l'entreprise (identité, immatriculations, délais, moyens de
 * paiement, garanties) est laissé en marqueur `[ … ]` plutôt qu'inventé : le
 * service juridique voit ainsi exactement ce qu'il doit compléter.
 *
 * Les pages affichent un bandeau d'avertissement tant que `isDraft` vaut true.
 */

const TODO = (label) => `[${label} — à compléter]`;

export const CGU = {
  id: "cgu",
  isDraft: true,
  kicker: "Informations légales",
  title: "Conditions générales d'utilisation et de vente",
  subtitle:
    "Les présentes conditions régissent l'utilisation du site Mondoviva et la réservation de nos voyages organisés.",
  updatedAt: TODO("Date de mise à jour"),
  sections: [
    {
      id: "objet",
      title: "Objet et acceptation",
      blocks: [
        {
          type: "p",
          text: "Les présentes conditions générales d'utilisation et de vente définissent les droits et obligations de Mondoviva et de tout utilisateur du site. Toute réservation d'un voyage implique l'acceptation pleine et entière des présentes conditions.",
        },
        {
          type: "p",
          text: "Mondoviva est une plateforme de vente de voyages organisés. Les prestations sont décrites sur chaque fiche voyage : durée, hébergement, transports et prestations incluses.",
        },
      ],
    },
    {
      id: "prix",
      title: "Prix et prestations",
      blocks: [
        {
          type: "p",
          text: "Les prix sont indiqués par personne, base chambre double, toutes taxes comprises. Ils comprennent les prestations listées sur la fiche voyage.",
        },
        {
          type: "ul",
          items: [
            "Ne sont pas inclus, sauf mention contraire : assurances, dépenses personnelles, excursions optionnelles et taxes de séjour.",
            "Les prix peuvent varier selon la date, la disponibilité et le nombre de voyageurs jusqu'à validation du panier.",
          ],
        },
      ],
    },
    {
      id: "reservation",
      title: "Réservation",
      blocks: [
        {
          type: "p",
          text: "La réservation s'effectue en ligne. Un message de confirmation portant la référence du dossier est envoyé après validation. Le voyageur s'engage à fournir des informations exactes, conformes à ses pièces d'identité.",
        },
        {
          type: "p",
          text: `Durée de validité d'une option posée sur un dossier : ${TODO(
            "Délai"
          )}.`,
        },
      ],
    },
    {
      id: "paiement",
      title: "Paiement",
      blocks: [
        {
          type: "p",
          text: `Moyens de paiement acceptés et modalités de débit : ${TODO(
            "Moyens de paiement retenus"
          )}. Les paiements sont sécurisés.`,
        },
      ],
    },
    {
      id: "annulation",
      title: "Annulation et modification",
      blocks: [
        {
          type: "p",
          text: `Conditions et délais d'annulation : ${TODO(
            "Barème d'annulation"
          )}. Au-delà du délai légal de rétractation applicable, les frais dépendent du dossier et de la proximité du départ.`,
        },
        {
          type: "p",
          text: `Conditions de modification des dates : ${TODO(
            "Délai et frais"
          )}, selon disponibilité.`,
        },
      ],
    },
    {
      id: "documents",
      title: "Documents de voyage",
      blocks: [
        {
          type: "p",
          text: "Les billets, bons d'échange et carnets de voyage sont transmis par message et restent consultables dans l'espace « Mes voyages ». Le voyageur doit vérifier la validité de ses pièces d'identité au regard de la destination.",
        },
      ],
    },
    {
      id: "responsabilite",
      title: "Responsabilité",
      blocks: [
        {
          type: "p",
          text: `Mondoviva est responsable de la bonne exécution des prestations vendues, dans les conditions prévues par la réglementation applicable : ${TODO(
            "Régime de responsabilité applicable"
          )}. Mondoviva ne saurait être tenu responsable des conséquences d'un cas de force majeure.`,
        },
      ],
    },
    {
      id: "reclamations",
      title: "Réclamations",
      blocks: [
        {
          type: "p",
          text: `Toute réclamation peut être adressée depuis la messagerie du site ou à l'adresse ${TODO(
            "Adresse de réclamation"
          )}.`,
        },
      ],
    },
  ],
};

export const MENTIONS = {
  id: "mentions-legales",
  isDraft: true,
  kicker: "Informations légales",
  title: "Mentions légales",
  subtitle:
    "Éditeur, hébergeur et conditions d'utilisation des contenus du site.",
  updatedAt: TODO("Date de mise à jour"),
  sections: [
    {
      id: "editeur",
      title: "Éditeur du site",
      blocks: [
        {
          type: "ul",
          items: [
            `Raison sociale et forme juridique : ${TODO("Raison sociale")}`,
            `Capital social : ${TODO("Capital")}`,
            `Immatriculation et numéro de TVA : ${TODO("Immatriculations")}`,
            `Siège social : ${TODO("Adresse")}`,
            `Immatriculation au registre des opérateurs de voyages : ${TODO(
              "Numéro"
            )}`,
          ],
        },
      ],
    },
    {
      id: "publication",
      title: "Directeur de la publication",
      blocks: [
        {
          type: "ul",
          items: [
            `Nom et qualité : ${TODO("Nom du représentant légal")}`,
            `Contact : ${TODO("Adresse électronique et téléphone")}`,
          ],
        },
      ],
    },
    {
      id: "hebergement",
      title: "Hébergement",
      blocks: [
        {
          type: "p",
          text: `Le site est hébergé par ${TODO(
            "Hébergeur, adresse et téléphone"
          )}.`,
        },
      ],
    },
    {
      id: "propriete",
      title: "Propriété intellectuelle",
      blocks: [
        {
          type: "p",
          text: "L'ensemble des contenus du site — textes, visuels, logo, code — est la propriété exclusive de Mondoviva ou de ses partenaires. Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.",
        },
        {
          type: "p",
          text: `Crédits photographiques : ${TODO("Crédits")}. Les visuels restent la propriété de leurs auteurs respectifs.`,
        },
      ],
    },
    {
      id: "mediation",
      title: "Médiation de la consommation",
      blocks: [
        {
          type: "p",
          text: `Organisme de médiation compétent et modalités de saisine : ${TODO(
            "Médiateur"
          )}.`,
        },
      ],
    },
  ],
};

export const CONFIDENTIALITE = {
  id: "confidentialite",
  isDraft: true,
  kicker: "Vos données",
  title: "Politique de confidentialité",
  subtitle:
    "Quelles données nous traitons, pourquoi, combien de temps, et comment exercer vos droits.",
  updatedAt: TODO("Date de mise à jour"),
  sections: [
    {
      id: "donnees",
      title: "Données collectées",
      blocks: [
        {
          type: "p",
          text: "Nous collectons les données nécessaires à la gestion de vos voyages et à votre usage du site :",
        },
        {
          type: "ul",
          items: [
            "Identité et contact : nom, prénom, adresse électronique, téléphone.",
            "Données de voyage : réservations, favoris, avis, messages échangés avec les agences.",
            "Données de paiement : traitées par nos prestataires, jamais conservées par Mondoviva.",
          ],
        },
      ],
    },
    {
      id: "finalites",
      title: "Finalités et durées de conservation",
      blocks: [
        {
          type: "table",
          head: ["Finalité", "Base légale", "Durée"],
          rows: [
            ["Gestion des réservations", "Exécution du contrat", TODO("Durée")],
            ["Support et messagerie", "Exécution du contrat", TODO("Durée")],
            ["Lettre d'information", "Consentement", "Jusqu'au désabonnement"],
            ["Mesure d'audience", "Consentement", TODO("Durée")],
          ],
        },
      ],
    },
    {
      id: "cookies",
      title: "Cookies",
      blocks: [
        {
          type: "p",
          text: "Les cookies strictement nécessaires au fonctionnement du site — session, sécurité, panier — ne requièrent pas de consentement. Les cookies de mesure d'audience et de personnalisation ne sont déposés qu'avec votre accord, modifiable à tout moment.",
        },
        {
          type: "p",
          text: `Liste détaillée des cookies déposés : ${TODO(
            "Inventaire des cookies"
          )}.`,
        },
      ],
    },
    {
      id: "droits",
      title: "Vos droits",
      blocks: [
        {
          type: "p",
          text: "Vous disposez des droits d'accès, de rectification, d'effacement, de portabilité, de limitation et d'opposition sur vos données. Vous pouvez les exercer depuis votre profil ou en nous écrivant.",
        },
        {
          type: "p",
          text: `Adresse d'exercice des droits, délai de réponse et autorité de contrôle compétente : ${TODO(
            "À préciser"
          )}.`,
        },
      ],
    },
    {
      id: "securite",
      title: "Sécurité",
      blocks: [
        {
          type: "p",
          text: "Vos données sont chiffrées pendant leur transport. L'accès est restreint aux personnels habilités, et nos prestataires sont choisis pour leurs garanties de sécurité.",
        },
      ],
    },
    {
      id: "contact",
      title: "Contact",
      blocks: [
        {
          type: "p",
          text: `Délégué à la protection des données et adresse de contact : ${TODO(
            "Coordonnées"
          )}.`,
        },
      ],
    },
  ],
};

/**
 * FAQ — les réponses décrivent ce que le portail fait réellement aujourd'hui.
 * Tout ce qui relève d'un engagement commercial (délais, moyens de paiement,
 * franchises bagage) reste en marqueur.
 */
export const FAQ = {
  id: "faq",
  isDraft: true,
  kicker: "Centre d'aide",
  title: "Questions fréquentes",
  subtitle:
    "Ce qu'il faut savoir avant, pendant et après votre voyage. Une question sans réponse ? Écrivez à votre agence depuis la messagerie.",
  groups: [
    {
      id: "reserver",
      title: "Réserver",
      items: [
        {
          q: "Comment réserver un voyage ?",
          a: "Choisissez votre voyage, sélectionnez une date de départ et le nombre de voyageurs, puis lancez la réservation. Vous renseignez ensuite les informations des voyageurs avant de confirmer le dossier.",
        },
        {
          q: "Puis-je réserver pour plusieurs personnes ?",
          a: "Oui. Au moment de choisir votre départ, indiquez le nombre d'adultes, d'enfants et de bébés : le tarif se recalcule automatiquement.",
        },
        {
          q: "Où retrouver ma réservation ?",
          a: "Dans « Mes voyages ». Chaque dossier donne accès au récapitulatif complet : programme, voyageurs, montants et référence.",
        },
      ],
    },
    {
      id: "paiement",
      title: "Paiement",
      items: [
        {
          q: "Quels moyens de paiement acceptez-vous ?",
          a: `${TODO("Moyens de paiement")}.`,
        },
        {
          q: "Un acompte est-il demandé ?",
          a: `${TODO("Modalités d'acompte et échéancier")}.`,
        },
      ],
    },
    {
      id: "modifier",
      title: "Modifier ou annuler",
      items: [
        {
          q: "Puis-je annuler ma réservation ?",
          a: `${TODO("Conditions et délais d'annulation")}. Les conditions propres à votre dossier sont consultables depuis « Mes voyages ».`,
        },
        {
          q: "Puis-je modifier mes dates ?",
          a: `${TODO("Délai et frais de modification")}. Écrivez à votre agence depuis la messagerie : elle vous proposera les alternatives disponibles.`,
        },
      ],
    },
    {
      id: "avant-depart",
      title: "Avant le départ",
      items: [
        {
          q: "Quels documents dois-je prévoir ?",
          a: "Une pièce d'identité en cours de validité, adaptée à la destination, et les documents de voyage transmis avec votre dossier. Les exigences propres à chaque destination figurent sur la fiche du voyage.",
        },
        {
          q: "Quand reçoit-on les documents de voyage ?",
          a: `${TODO("Délai d'envoi des documents")}. Ils restent disponibles dans « Mes voyages ».`,
        },
      ],
    },
    {
      id: "apres",
      title: "Après le voyage",
      items: [
        {
          q: "Comment laisser un avis ?",
          a: "Depuis « Mes voyages », onglet « Voyages passés » : chaque voyage terminé propose de laisser un avis. Vous notez le voyage sur plusieurs critères et rédigez votre commentaire.",
        },
        {
          q: "Puis-je réserver à nouveau le même voyage ?",
          a: "Oui. Une fois votre avis déposé, la carte du voyage passé propose de le réserver à nouveau et vous emmène sur les prochains départs disponibles.",
        },
      ],
    },
  ],
};

const legalContent = { CGU, MENTIONS, CONFIDENTIALITE, FAQ };

export default legalContent;
